module.exports = __webpack_public_path__ + "static/media/twitterIcon.2768551d.png";